import Sidebar from "../components/Sidebar";

const Root = ({ children }) => {
  const containerStyle = {
    marginLeft: "var(--sidebar-width, 256px)",
    width: "calc(100% - var(--sidebar-width, 256px))",
  };

  return (
    <>
      <Sidebar />
      <div
        className="px-4 pt-4 pb-10 app-container"
        style={containerStyle}
      >
        {children}
        <div className="white-container"></div>
      </div>
    </>
  );
};

export default Root;
